// extracted by mini-css-extract-plugin
export default {"container":"SupplierForm_container__yFCCQ","button":"SupplierForm_button__35NsO","row":"SupplierForm_row__xu7LC","input":"SupplierForm_input__kCcul"};